import xs from 'xstream';
import BASE_URL from './variables';
import { requestStagedPremiumSettingsStages,createStagedPremium, failedCreateStagedPremium, failedPatchStagedPremium,
	 patchStagedPremium, successCreateStagedPremium,successPatchStagedPremium,
	  receiveStagedPremiumSettingsStages, failedStagedPremiumSettingsStages, resetStagedWizardState } from '../reducers/stagedPremiumsWizard';
import { resetStagedPremiumState } from '../reducers/stagedPremiums';

export function createStagedPremiumSetting(sources) {

	const request$ = sources.ACTION
		.filter(action => action.type === createStagedPremium.type)
		.map(action => ({
			url: BASE_URL + "api/PremiumSettings/staged" ,
			category: 'createStagedPremium',
			method: 'POST',
            send: action.payload,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('createStagedPremium')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 201)
		.map(response => successCreateStagedPremium(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestCreateStagedPremiumSetting(sources) {
	let httpResponse$ = sources.HTTP
		.select('createStagedPremium')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 201)
		.map(response =>failedCreateStagedPremium(response));

	return {
		ACTION: httpResponse$
	};
}

export function requestPatchStagedPremiumSettings(sources) {

	const request$ = sources.ACTION
		.filter(action => action.type === patchStagedPremium.type)
		.map(action => ({
			url: BASE_URL + "api/PremiumSettings/Staged/" + action.payload.id,
			category: 'patchStagedPremiums',
			method: 'PATCH',
            send: action.payload.body,
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('patchStagedPremiums')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => successPatchStagedPremium(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function receiveBadRequestPatchStagedPremiumSettings(sources) {
	let httpResponse$ = sources.HTTP
		.select('patchStagedPremiums')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => failedPatchStagedPremium(response));

	return {
		ACTION: httpResponse$
	};
}
export function getStagedPremiumSettingsStages(sources) {

	const request$ = sources.ACTION
		.filter(action => action.type === requestStagedPremiumSettingsStages.type)
		.map(action => ({
			url: BASE_URL + "api/PremiumSettings/Staged/Stages",
			category: 'getStagedPremiumsStages',
			method: 'GET',
			type: 'application/json',
			withCredentials: true
		}));

	let httpResponse$ = sources.HTTP
		.select('getStagedPremiumsStages')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status === 200)
		.map(response => receiveStagedPremiumSettingsStages(JSON.parse(response.text)));

	return {
		ACTION: httpResponse$,
		HTTP: request$
	};
}

export function failedGetStagedPremiumSettingsStages(sources) {
	let httpResponse$ = sources.HTTP
		.select('getStagedPremiumsStages')
		.map((response) =>
			response.replaceError((err) => xs.of(err))
		)
		.flatten()
		.filter(response => response.status !== 200)
		.map(response => failedStagedPremiumSettingsStages(response));

	return {
		ACTION: httpResponse$
	};
}
export function resetStagedPremiumReducers(sources) {
	const dispatched$ = sources.ACTION
		.filter(action => action.type === '@@router/LOCATION_CHANGE')
		.map(action => xs.of(resetStagedWizardState(),resetStagedPremiumState())).flatten();

	return {
		ACTION: dispatched$,
	};
}